export default "__VITE_ASSET__CqWHqdf5__"